import { render } from "./ProjectProcureEndDateForm.vue?vue&type=template&id=67f7d396&scoped=true&ts=true"
import script from "./ProjectProcureEndDateForm.ts?vue&type=script&lang=ts"
export * from "./ProjectProcureEndDateForm.ts?vue&type=script&lang=ts"

import "./ProjectProcureEndDateForm.scss?vue&type=style&index=0&id=67f7d396&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f7d396"]])

export default __exports__